// assert-exactly-one.ts
function assertExactlyOne(items, message) {
  if (items.length !== 1) {
    throw new Error(message ?? `Expected exactly one item, but got ${items.length}`);
  }
  return [items[0]];
}
export {
  assertExactlyOne
};
